import { GET_TIPO_CAMBIO, GET_TIPO_CAMBIO_ERROR } from "./types";
import tipoCambioService from "app/@Base/services/tipoCambio.service";

export function getTipoCambio() {
  return function (dispatch) {
    try {
      return tipoCambioService.reqTipoCambio().then((data) => {
        dispatch({
          type: GET_TIPO_CAMBIO,
          payload: data,
        });
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_TIPO_CAMBIO_ERROR,
          payload: false,
        });
      };
    }
  };
}